import { Popover } from '@chakra-ui/react/popover';
import { Portal } from '@chakra-ui/react/portal';
import { RefObject } from 'react';

import { SimplePublicApiApp } from '@/models/App';

import AppList from './AppList';

type SearchResultsProps = {
  /** The header's search box, which the panel hangs off — its field is what the results answer. */
  anchorRef: RefObject<HTMLDivElement | null>;
  apps: SimplePublicApiApp[];
  onFocusReset: () => void;
};

/**
 * The results of the header search. `BitkitUIHeader.Search` owns the field and nothing else: what a
 * search turns up is per product, so the panel is ours.
 */
const SearchResults = ({ anchorRef, apps, onFocusReset }: SearchResultsProps) => (
  // The field keeps focus while the results open beside it, so the search box anchors the popover
  // rather than being its trigger.
  <Popover.Root
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus={false}
    open
    positioning={{ getAnchorElement: () => anchorRef.current, gutter: 8, placement: 'bottom-end' }}
  >
    <Portal>
      <Popover.Positioner>
        <Popover.Content paddingBlock="8">
          <AppList apps={apps} isOpen onFocusReset={onFocusReset} />
        </Popover.Content>
      </Popover.Positioner>
    </Portal>
  </Popover.Root>
);

export default SearchResults;
